import { render, staticRenderFns } from "./TestColumnModule.vue?vue&type=template&id=24949bb7&scoped=true"
import script from "./TestColumnModule.vue?vue&type=script&lang=js"
export * from "./TestColumnModule.vue?vue&type=script&lang=js"
import style0 from "./TestColumnModule.vue?vue&type=style&index=0&id=24949bb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24949bb7",
  null
  
)

export default component.exports